import React from "react";

const PageBanner = ({
    image,
    imageAlt,
    children,
    className = "",
    imgClassName = "",
    contentClassName = "",
}) => {
    return (
        <div
            className={`
        relative
        w-full
        overflow-hidden
        bg-gray-900
        aspect-[1920/855]
        ${className}
      `}
        >
            <img
                src={image}
                alt={imageAlt}
                className={`
          absolute
          inset-0
          w-full
          h-full
          object-cover
          object-center
          ${imgClassName}
        `}
            />

            {children && (
                <div
                    className={`
            relative
            z-10
            flex
            flex-col
            justify-center
            h-full
            px-4
            md:px-20
            max-w-7xl
            mx-auto
            ${contentClassName}
          `}
                >
                    {children}
                </div>
            )}
        </div>
    );
};

export default PageBanner;
